import { postRegister, postVerifyOtp } from '../services/authservices';
import { Otp, Register } from '../constant/serviceType';
import { NavigateFunction } from 'react-router-dom';

export const registerUser = async (payload: Register) => {
  let userResponse = null;

  try {
    const response = await postRegister(payload);
    console.log('registerUser', response);
    userResponse = response?.data?.data.user;
    if (userResponse) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      // const { access_token } = userResponse;
      // navigate('/login');
      return { success: true, user: userResponse };
    }
  } catch (e: any) {
    console.log(e.response.data);
    const allErrors = e.response?.data?.errors;
    const firstError = allErrors ? Object.values(allErrors).find(error => error) : e.response.data.message;
    console.log('kddk', allErrors );
    return { success: false, error: firstError };
  }
};


export const verifyOtp = async (payload: Otp, navigate: NavigateFunction) => {
  let userResponse = null;
  try {
    const response = await postVerifyOtp(payload);
    // console.log('registerUser', response);
    userResponse = response?.data?.data;
    if (userResponse) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const access_token = 'verified';
      navigate('/app/dashboard');
      return { success: true, data: access_token, user: userResponse };
    }
  } catch (e: any) {
    // console.log(e.response.data.message);
    return { success: false, error: e.response.data.message };
  }

  return userResponse;
};
